import React from "react";
import { cn } from "@/lib/utils";
import { UserCheck, X } from "lucide-react";
import { buttonVariants, Skeleton } from "./ui";
import { useTranslation } from "react-i18next";

interface SelectedStudentsCardProps {
  className?: string;
  description: string;
  loading: boolean;
  onClear: () => void;
}

export const SelectedStudentCountCard = ({
  className,
  description,
  onClear,
  loading,
}: SelectedStudentsCardProps) => {
  const { t } = useTranslation();

  return (
    <div className={cn("rounded-md border bg-table-accent p-4", className)}>
      <div className="flex justify-between gap-2">
        <div className="flex items-center gap-2">
          <UserCheck className="my-1 size-4 text-sm" />
          {loading ? (
            <Skeleton className="h-4 w-35 bg-skeleton-dark" />
          ) : (
            <div>
              <span>{description}</span>
            </div>
          )}
        </div>
        <button className="flex items-center gap-2" onClick={onClear}>
          <span className="">{t("global.clear")}</span>
          <div className={cn(buttonVariants({ variant: "outline" }), "size-8")}>
            <X />
          </div>
        </button>
      </div>
    </div>
  );
};
